export default function Footer() {
  const navigateToPage = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-purple-500 via-pink-400 to-blue-400 text-white">
      <div className="px-4 sm:px-6 lg:px-20 py-12 sm:py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 lg:gap-16 mb-12 sm:mb-16">
          <div>
            <img 
              src="https://static.readdy.ai/image/d367af92f7f38cbe19d536434073c925/e0a38c2585532f9a804a48c9264dc408.png" 
              alt="KIMURAMA WORKS" 
              className="h-12 sm:h-14 lg:h-16 mb-6 sm:mb-8"
            />
            <p className="text-base font-medium text-white/90 leading-relaxed mb-8 sm:mb-10 max-w-xs">
              AIを人に届ける、伴走型コンサルティング。<br />
              業務設計から定着まで、確実な成果を支援します。
            </p>
            
            <div className="flex gap-4">
              <a
                href="https://lin.ee/UR2Ncy5"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/80 flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-line-fill text-white text-lg"></i>
              </a>
              <a
                href="mailto:km.works.aidesign@gmail.com"
                className="w-10 h-10 rounded-full border-2 border-white/80 flex items-center justify-center hover:border-white hover:bg-white/10 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-mail-line text-white text-lg"></i>
              </a>
            </div>
          </div>
          
          <div className="space-y-6 sm:space-y-8">
            <div>
              <p className="text-xs font-semibold text-white/70 mb-3 tracking-wider">NAVIGATION</p>
              <div className="space-y-2">
                <button
                  onClick={() => scrollToSection('services')}
                  className="block text-base font-medium text-white hover:text-white/80 transition-colors cursor-pointer"
                >
                  サービス
                </button>
                <button
                  onClick={() => scrollToSection('about')}
                  className="block text-base font-medium text-white hover:text-white/80 transition-colors cursor-pointer"
                >
                  私について
                </button>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="block text-base font-medium text-white hover:text-white/80 transition-colors cursor-pointer"
                >
                  お客様の声
                </button>
                <button
                  onClick={() => navigateToPage('/blog')}
                  className="block text-base font-medium text-white hover:text-white/80 transition-colors cursor-pointer"
                >
                  ブログ
                </button>
              </div>
            </div>
            
            <div>
              <p className="text-xs font-semibold text-white/70 mb-2 tracking-wider">EMAIL</p>
              <a 
                href="mailto:km.works.aidesign@gmail.com"
                className="text-base font-medium text-white hover:text-white/80 transition-colors break-all"
              >
                km.works.aidesign@gmail.com
              </a>
            </div>
            
            <div>
              <p className="text-xs font-semibold text-white/70 mb-2 tracking-wider">LINE</p>
              <a 
                href="https://lin.ee/UR2Ncy5"
                target="_blank"
                rel="noopener noreferrer"
                className="text-base font-medium text-white hover:text-white/80 transition-colors"
              >
                公式LINE
              </a>
            </div>
          </div>
          
          <div className="flex justify-center md:justify-end">
            <div className="w-40 h-56 sm:w-48 sm:h-64 lg:w-52 lg:h-72 rounded-lg overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-500">
              <img 
                src="https://static.readdy.ai/image/d367af92f7f38cbe19d536434073c925/83ac659fa307c4f5e1f7dddba24178f6.png" 
                alt="木村まこ" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="border-t border-white/20">
        <div className="px-4 sm:px-6 lg:px-20 py-4 sm:py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs font-medium text-white/80 text-center sm:text-left">
            © 2025 KIMURAMA WORKS. All rights reserved.
          </p>
          
          <div className="flex items-center gap-4 sm:gap-6">
            <img 
              src="https://static.readdy.ai/image/d367af92f7f38cbe19d536434073c925/e0a38c2585532f9a804a48c9264dc408.png" 
              alt="KIMURAMA WORKS" 
              className="h-6 sm:h-8 opacity-80"
            />
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs font-medium text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}